import styled from 'styled-components';
import Typography from '@klv/atoms/typography';
import Buttons from '@klv/molecules/buttons';
import type { ITypography } from '@klv/atoms/typography/variants/types';
import type { IColorVariants } from '../types';

export const StyledBorder = styled.hr<IColorVariants>`
${({ theme, $variant }) => `
  grid-column: 1 / -1;
  background: transparent;
  border:0;
  border-top: 1px solid ${theme.featuresList[$variant].borderColor};
  height: 1px;
  margin: 5rem 0;
  margin: 2.4rem 0;
  ${theme.screenSize.s768.mediaQuery} {
    grid-column: 2 / -1;
    margin: 3.2rem 0;
  }
  ${theme.screenSize.s1024.mediaQuery} {
    grid-column: 2 / -1;
    margin: 5rem 0;
  }
`}
`;
export const StyledHeaderContent = styled(Typography)`
${({ theme }) => `
  grid-column: 1 / -1;
  margin-bottom: 1.2rem;

  ${theme.screenSize.s768.mediaQuery} {
    margin-bottom: 1.1rem;
  }

  ${theme.screenSize.s1024.mediaQuery} {
    grid-column: 2 / 4;
    margin-bottom: 1.6rem;
  }
`}
`;

export const StyledHeaderLeftContent = styled(Typography)`
${({ theme }) => `
  grid-column: 1 / -1;
  margin-bottom: 2.4rem;
  ${theme.fonts.sohne.regular}
  font-size: 2.4rem;
  line-height: 2.8rem;

  ${theme.screenSize.s768.mediaQuery} {
    margin-bottom: 1.1rem;
    grid-column: 2 / -1;
  }

  ${theme.screenSize.s1024.mediaQuery} {
    grid-column: 2 / 5;
    margin-bottom: 1.6rem;
    font-size: 2.8rem;
    line-height: 3.4rem;
  }
`}
`;

export const Feature = styled.div<{ $type: string; }>`
${({ theme, $type }) => `
  grid-column: 1 / -1;
  ${theme.screenSize.s768.mediaQuery} {
    grid-column: ${$type === 'text' ? '2 / 12' : '6 / 12'};
  }
  ${theme.screenSize.s1024.mediaQuery} {
    grid-column: 6 / 12;
  }
`}
`;

export const StyledBodyContent = styled(Typography)<ITypography>`
white-space: pre-wrap;
`;

export const StyledButtons = styled(Buttons)`
padding-top: 3.2rem;
`;
